import { create } from 'zustand';

type AddManagerModalStoreProps = {
	isOpen: boolean;
	onClose: () => void;
	onOpen: () => void;
};

export const useAddManagerModalStore = create<AddManagerModalStoreProps>((set) => ({
	isOpen: false,
	onClose: () => set({ isOpen: false }),
	onOpen: () => set({ isOpen: true }),
}));

export const useAddManagerModal = () => useAddManagerModalStore((state) => state);
